module.exports = __webpack_public_path__ + "img/water.ece9c4ec.png";